import { TransactionDirectionCode, transactionDirectionnMap } from '@tassat/common-definitions';
import React from 'react';

interface DirectionCellRenderProps {
    value: TransactionDirectionCode;
}

const DirectionCellRender = ({ value }: DirectionCellRenderProps) => {
    return (
        <span>{transactionDirectionnMap(value)}</span>
    );
};

export default DirectionCellRender;